module.exports = __webpack_public_path__ + "media/images/benefits-modal-2025-2d5ba41cb98749f3461844d5b9fd6eda.jpeg";